/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react'
// svg avatars
// default
import { ReactComponent as Default1 } from './avatarspack/default/Default1.svg'
import { ReactComponent as Default2 } from './avatarspack/default/Default2.svg'
import { ReactComponent as Default3 } from './avatarspack/default/Default3.svg'
import { ReactComponent as Default4 } from './avatarspack/default/Default4.svg'
import { ReactComponent as Default5 } from './avatarspack/default/Default5.svg'
import { ReactComponent as Default6 } from './avatarspack/default/Default6.svg'
import { ReactComponent as Default7 } from './avatarspack/default/Default7.svg'
import { ReactComponent as Default8 } from './avatarspack/default/Default8.svg'
import { ReactComponent as Default9 } from './avatarspack/default/Default9.svg'
import { ReactComponent as Default10 } from './avatarspack/default/Default10.svg'
import { ReactComponent as Default11 } from './avatarspack/default/Default11.svg'
import { ReactComponent as Default12 } from './avatarspack/default/Default12.svg'
// entertainment
import { ReactComponent as Entertainment1 } from './avatarspack/entertainment/MusicalNote.svg'
import { ReactComponent as Entertainment2 } from './avatarspack/entertainment/GlowingStar.svg'
import { ReactComponent as Entertainment3 } from './avatarspack/entertainment/MovieCamera.svg'
import { ReactComponent as Entertainment4 } from './avatarspack/entertainment/Microphone.svg'
import { ReactComponent as Entertainment5 } from './avatarspack/entertainment/Radio.svg'
import { ReactComponent as Entertainment6 } from './avatarspack/entertainment/Ticket.svg'
import { ReactComponent as Entertainment7 } from './avatarspack/entertainment/Guitar.svg'
import { ReactComponent as Entertainment8 } from './avatarspack/entertainment/Sax.svg'
import { ReactComponent as Entertainment9 } from './avatarspack/entertainment/Accordion.svg'
import { ReactComponent as Entertainment10 } from './avatarspack/entertainment/Violin.svg'
import { ReactComponent as Entertainment11 } from './avatarspack/entertainment/Party.svg'
import { ReactComponent as Entertainment12 } from './avatarspack/entertainment/Joystick.svg'
// hobbies
import { ReactComponent as Hobbies1 } from './avatarspack/hobbies/Masks.svg'
import { ReactComponent as Hobbies2 } from './avatarspack/hobbies/Darts.svg'
import { ReactComponent as Hobbies3 } from './avatarspack/hobbies/Skateboard.svg'
import { ReactComponent as Hobbies4 } from './avatarspack/hobbies/Yoyo.svg'
import { ReactComponent as Hobbies5 } from './avatarspack/hobbies/Bike.svg'
import { ReactComponent as Hobbies6 } from './avatarspack/hobbies/Paints.svg'
import { ReactComponent as Hobbies7 } from './avatarspack/hobbies/Plane.svg'
import { ReactComponent as Hobbies8 } from './avatarspack/hobbies/Glasses.svg'
import { ReactComponent as Hobbies9 } from './avatarspack/hobbies/Car.svg'
import { ReactComponent as Hobbies10 } from './avatarspack/hobbies/Dice.svg'
import { ReactComponent as Hobbies11 } from './avatarspack/hobbies/Motorcycle.svg'
import { ReactComponent as Hobbies12 } from './avatarspack/hobbies/Stump.svg'
// sports
import { ReactComponent as Sports1 } from './avatarspack/sports/Golf.svg'
import { ReactComponent as Sports2 } from './avatarspack/sports/Fishing.svg'
import { ReactComponent as Sports3 } from './avatarspack/sports/Eightball.svg'
import { ReactComponent as Sports4 } from './avatarspack/sports/Football.svg'
import { ReactComponent as Sports5 } from './avatarspack/sports/Skates.svg'
import { ReactComponent as Sports6 } from './avatarspack/sports/Soccer.svg'
import { ReactComponent as Sports7 } from './avatarspack/sports/Pingpong.svg'
import { ReactComponent as Sports8 } from './avatarspack/sports/Tennis.svg'
import { ReactComponent as Sports9 } from './avatarspack/sports/Baseball.svg'
import { ReactComponent as Sports10 } from './avatarspack/sports/Basketball.svg'
import { ReactComponent as Sports11 } from './avatarspack/sports/Bowling.svg'
import { ReactComponent as Sports12 } from './avatarspack/sports/Hockey.svg'
// home
import { ReactComponent as Home1 } from './avatarspack/home/Dog.svg'
import { ReactComponent as Home2 } from './avatarspack/home/Cat.svg'
import { ReactComponent as Home3 } from './avatarspack/home/Unicorn.svg'
import { ReactComponent as Home4 } from './avatarspack/home/Butterfly.svg'
import { ReactComponent as Home5 } from './avatarspack/home/Rainbow.svg'
import { ReactComponent as Home6 } from './avatarspack/home/Bolt.svg'
import { ReactComponent as Home7 } from './avatarspack/home/CarHome.svg'
import { ReactComponent as Home8 } from './avatarspack/home/Truck.svg'
import { ReactComponent as Home9 } from './avatarspack/home/Boomerang.svg'
import { ReactComponent as Home10 } from './avatarspack/home/Camera.svg'
import { ReactComponent as Home11 } from './avatarspack/home/DiceHome.svg'
import { ReactComponent as Home12 } from './avatarspack/home/Flowers.svg'
// science
import { ReactComponent as Science1 } from './avatarspack/science/Rocket.svg'
import { ReactComponent as Science2 } from './avatarspack/science/Briefcase.svg'
import { ReactComponent as Science3 } from './avatarspack/science/Testtube.svg'
import { ReactComponent as Science4 } from './avatarspack/science/Labcoat.svg'
import { ReactComponent as Science5 } from './avatarspack/science/Dna.svg'
import { ReactComponent as Science6 } from './avatarspack/science/Microscope.svg'
import { ReactComponent as Science7 } from './avatarspack/science/Telescope.svg'
import { ReactComponent as Science8 } from './avatarspack/science/Stethoscope.svg'
import { ReactComponent as Science9 } from './avatarspack/science/Globe.svg'
import { ReactComponent as Science10 } from './avatarspack/science/Magnet.svg'
import { ReactComponent as Science11 } from './avatarspack/science/Rocket.svg'
import { ReactComponent as Science12 } from './avatarspack/science/SignalPlate.svg'
// educational
import { ReactComponent as Educational1 } from './avatarspack/educational/LightGlobe.svg'
import { ReactComponent as Educational2 } from './avatarspack/educational/GlobeAmericas.svg'
import { ReactComponent as Educational3 } from './avatarspack/educational/GlobeAsia.svg'
import { ReactComponent as Educational4 } from './avatarspack/educational/Law.svg'
import { ReactComponent as Educational5 } from './avatarspack/educational/Clock.svg'
import { ReactComponent as Educational6 } from './avatarspack/educational/Notepad.svg'
import { ReactComponent as Educational7 } from './avatarspack/educational/News.svg'
import { ReactComponent as Educational8 } from './avatarspack/educational/ChineseCalculator.svg'
import { ReactComponent as Educational9 } from './avatarspack/educational/Backpack.svg'
import { ReactComponent as Educational10 } from './avatarspack/educational/Book.svg'
import { ReactComponent as Educational11 } from './avatarspack/educational/Gradcap.svg'
import { ReactComponent as Educational12 } from './avatarspack/educational/NewsRolled.svg'
// news
import { ReactComponent as News1 } from './avatarspack/news/Globe.svg'
import { ReactComponent as News2 } from './avatarspack/news/GlobeMeridian.svg'
import { ReactComponent as News3 } from './avatarspack/news/MovieCamera.svg'
import { ReactComponent as News4 } from './avatarspack/news/Newspaper.svg'
import { ReactComponent as News5 } from './avatarspack/news/RolledupNewspaper.svg'
import { ReactComponent as News6 } from './avatarspack/news/Radio.svg'
import { ReactComponent as News7 } from './avatarspack/news/Microphone.svg'
import { ReactComponent as News8 } from './avatarspack/news/Satellite.svg'
import { ReactComponent as News9 } from './avatarspack/news/Megaphone.svg'
import { ReactComponent as News10 } from './avatarspack/news/Tv.svg'
import { ReactComponent as News11 } from './avatarspack/news/Helicopter.svg'
import { ReactComponent as News12 } from './avatarspack/news/Van.svg'
// styles
import injectSheet from 'react-jss'
import styles from './avatar_styles'

const avatarMap = {
  'GENERAL_1': <Default1 />,
  'GENERAL_2': <Default2 />,
  'GENERAL_3': <Default3 />,
  'GENERAL_4': <Default4 />,
  'GENERAL_5': <Default5 />,
  'GENERAL_6': <Default6 />,
  'GENERAL_7': <Default7 />,
  'GENERAL_8': <Default8 />,
  'GENERAL_9': <Default9 />,
  'GENERAL_10': <Default10 />,
  'GENERAL_11': <Default11 />,
  'GENERAL_12': <Default12 />,

  'ENTERTAINMENT_1': <Entertainment1 />,
  'ENTERTAINMENT_2': <Entertainment2 />,
  'ENTERTAINMENT_3': <Entertainment3 />,
  'ENTERTAINMENT_4': <Entertainment4 />,
  'ENTERTAINMENT_5': <Entertainment5 />,
  'ENTERTAINMENT_6': <Entertainment6 />,
  'ENTERTAINMENT_7': <Entertainment7 />,
  'ENTERTAINMENT_8': <Entertainment8 />,
  'ENTERTAINMENT_9': <Entertainment9 />,
  'ENTERTAINMENT_10': <Entertainment10 />,
  'ENTERTAINMENT_11': <Entertainment11 />,
  'ENTERTAINMENT_12': <Entertainment12 />,

  'HOBBIES_AND_INTERESTS_1': <Hobbies1 />,
  'HOBBIES_AND_INTERESTS_2': <Hobbies2 />,
  'HOBBIES_AND_INTERESTS_3': <Hobbies3 />,
  'HOBBIES_AND_INTERESTS_4': <Hobbies4 />,
  'HOBBIES_AND_INTERESTS_5': <Hobbies5 />,
  'HOBBIES_AND_INTERESTS_6': <Hobbies6 />,
  'HOBBIES_AND_INTERESTS_7': <Hobbies7 />,
  'HOBBIES_AND_INTERESTS_8': <Hobbies8 />,
  'HOBBIES_AND_INTERESTS_9': <Hobbies9 />,
  'HOBBIES_AND_INTERESTS_10': <Hobbies10 />,
  'HOBBIES_AND_INTERESTS_11': <Hobbies11 />,
  'HOBBIES_AND_INTERESTS_12': <Hobbies12 />,

  'SPORTS_1': <Sports1 />,
  'SPORTS_2': <Sports2 />,
  'SPORTS_3': <Sports3 />,
  'SPORTS_4': <Sports4 />,
  'SPORTS_5': <Sports5 />,
  'SPORTS_6': <Sports6 />,
  'SPORTS_7': <Sports7 />,
  'SPORTS_8': <Sports8 />,
  'SPORTS_9': <Sports9 />,
  'SPORTS_10': <Sports10 />,
  'SPORTS_11': <Sports11 />,
  'SPORTS_12': <Sports12 />,

  'HOME_1': <Home1 />,
  'HOME_2': <Home2 />,
  'HOME_3': <Home3 />,
  'HOME_4': <Home4 />,
  'HOME_5': <Home5 />,
  'HOME_6': <Home6 />,
  'HOME_7': <Home7 />,
  'HOME_8': <Home8 />,
  'HOME_9': <Home9 />,
  'HOME_10': <Home10 />,
  'HOME_11': <Home11 />,
  'HOME_12': <Home12 />,

  'SCIENCE_1': <Science1 />,
  'SCIENCE_2': <Science2 />,
  'SCIENCE_3': <Science3 />,
  'SCIENCE_4': <Science4 />,
  'SCIENCE_5': <Science5 />,
  'SCIENCE_6': <Science6 />,
  'SCIENCE_7': <Science7 />,
  'SCIENCE_8': <Science8 />,
  'SCIENCE_9': <Science9 />,
  'SCIENCE_10': <Science10 />,
  'SCIENCE_11': <Science11 />,
  'SCIENCE_12': <Science12 />,

  'EDUCATION_AND_PROFESSIONAL_1': <Educational1 />,
  'EDUCATION_AND_PROFESSIONAL_2': <Educational2 />,
  'EDUCATION_AND_PROFESSIONAL_3': <Educational3 />,
  'EDUCATION_AND_PROFESSIONAL_4': <Educational4 />,
  'EDUCATION_AND_PROFESSIONAL_5': <Educational5 />,
  'EDUCATION_AND_PROFESSIONAL_6': <Educational6 />,
  'EDUCATION_AND_PROFESSIONAL_7': <Educational7 />,
  'EDUCATION_AND_PROFESSIONAL_8': <Educational8 />,
  'EDUCATION_AND_PROFESSIONAL_9': <Educational9 />,
  'EDUCATION_AND_PROFESSIONAL_10': <Educational10 />,
  'EDUCATION_AND_PROFESSIONAL_11': <Educational11 />,
  'EDUCATION_AND_PROFESSIONAL_12': <Educational12 />,

  'NEWS_1': <News1 />,
  'NEWS_2': <News2 />,
  'NEWS_3': <News3 />,
  'NEWS_4': <News4 />,
  'NEWS_5': <News5 />,
  'NEWS_6': <News6 />,
  'NEWS_7': <News7 />,
  'NEWS_8': <News8 />,
  'NEWS_9': <News9 />,
  'NEWS_10': <News10 />,
  'NEWS_11': <News11 />,
  'NEWS_12': <News12 />,
}
/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : USER STATUS BADGE ~~~~~~~~~~ ========== */
const Avatar = injectSheet(styles)(({ classes, name, extension }) => {
  return <div className={`avatar ${classes.avatar}`}>
    {avatarMap[name]}
  </div>
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Avatar